import { call, put, select } from "redux-saga/effects";
import { getItemsFailure } from "../actions";
import { selectNextPage } from "../selectors";
import { GetItemsRequestProps } from "src/modules/modules.type";
import { ListFieldsKeys } from "src/api/config";
import { getItemsRequest } from "../api";

export function* getDefaultSaga(payload: GetItemsRequestProps<ListFieldsKeys>) {

  try {
    if (payload) {
      if (payload.nextPage && !payload.perPageState) {
        payload.nextPage = yield select(selectNextPage, payload.listName);
      }

      // Используем универсальную функцию, которая автоматически выбирает между SharePoint и Strapi
      const result: unknown = yield call(getItemsRequest, payload);
      return result;
    }
  } catch (error) {
    console.log(error);
    yield put(getItemsFailure({ listName: payload.listName, error }));
  }
}
